<mat-toolbar class="content-header" [ngClass]="{'vertical': isLandscape}">
  <mat-toolbar-row class="toolbar-row">
    <h1 class="page-title" [matTooltip]="isMobile ? ('stream.title' | translate) : undefined">
      <mat-icon fontIcon="switch_video"></mat-icon>
      <span *ngIf="!isMobile">{{'stream.title' | translate}}</span>
      <ng-container *ngIf="hasJoined() && !isMobile">
        <ng-container *ngTemplateOutlet="sessionDateBadge"></ng-container>
      </ng-container>
    </h1>
    <div *ngIf="hasJoined()" class="streamers">
      @for (user of invited; track user.email) {
        <app-user-avatar [avatarUrl]="user.avatar" [fullName]="displayName(user)" [size]="36"
          icon="hourglass_empty" [matTooltip]="displayName(user)">
        </app-user-avatar>
      }
      <div class="invite">
        <lib-button icon="person_add" class="" size="large" color="none"
          textColor="secondary"
          [tooltip]="'stream.invite.title' | translate" (click)="openInviteDialog()">
        </lib-button>
      </div>
    </div>
    <div class="actions" *ngIf="hasJoined()">
      <lib-button icon="photo_library" class="" color="none"
        [textColor]="showGallery ? 'secondary' : 'disabled'"
        [tooltip]="(showGallery ? 'stream.gallery.hide' : 'stream.gallery.show') | translate" (click)="toggleGallery()"></lib-button>
      <lib-button
        icon="logout"
        color="none"
        textColor="danger"
        tooltip="{{'stream.leave' | translate}}"
        (click)="leaveRoom()">
      </lib-button>
    </div>

    <div class="actions" *ngIf="!hasJoined() && !joiningRoom">
      <lib-button
        icon="videocam"
        color="secondary"
        [text]="isMobile ? '' : ('stream.start_tracker_session' | translate)"
        [tooltip]="'stream.start_tracker_session' | translate"
        (click)="createNewSession('tracker')">
      </lib-button>
      <lib-button
        icon="add"
        color="primary"
        [text]="isMobile ? '' : ('stream.start_session' | translate)"
        [tooltip]="'stream.start_session' | translate"
        (click)="createNewSession()">
      </lib-button>
    </div>
  </mat-toolbar-row>
  <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="room-info" *ngIf="!isPublisher() && !isViewer() && !joiningRoom" [class.landscape-mode]="isLandscape" [class.sidebar-open]="showVisitSidebar">
  <div class="visit-sidebar" *ngIf="showVisitSidebar">
    <div class="sidebar-close" *ngIf="isMobile">
      <lib-button icon="close" color="none" class="action" (click)="closeVisitSidebar()"></lib-button>
    </div>
    <div class="sidebar-header">
      <ng-container *ngIf="event && invitedAsPublisher(event); else visitDetailsTitle">
        <ng-container *ngTemplateOutlet="sessionDateBadge; context: { showLabel: false }"></ng-container>
      </ng-container>
      <ng-template #visitDetailsTitle><h3>{{ 'stream.visit_details' | translate }}</h3></ng-template>
      <div class="header-actions" *ngIf="event">
        <ng-container *ngIf="!event.endDate">
          <lib-button
            *ngIf="canJoinDirectly(event)"
            icon="login"
            color="none"
            size="large"
            textColor="secondary"
            [text]="'stream.join.label' | translate"
            [tooltip]="'stream.join.label' | translate"
            (click)="joinDirect(event)">
          </lib-button>
          <ng-container *ngIf="!canJoinDirectly(event)">
            <lib-button
              icon="login"
              color="none"
              size="large"
              textColor="secondary"
              [text]="'stream.join.label' | translate"
              [tooltip]="'stream.join.label' | translate"
              [matMenuTriggerFor]="joinMenu">
            </lib-button>
            <mat-menu #joinMenu="matMenu">
              <button mat-menu-item (click)="joinAsPublisher()" [disabled]="hasOtherPublisher(event)">
                <mat-icon>videocam</mat-icon>
                <span>{{ 'stream.join.as_publisher' | translate }}</span>
              </button>
              <button mat-menu-item (click)="joinAsViewer()">
                <mat-icon>visibility</mat-icon>
                <span>{{ 'stream.join.as_observer' | translate }}</span>
              </button>
            </mat-menu>
          </ng-container>
        </ng-container>
        <lib-button
          *ngIf="!event.endDate || (['admin','dev'].includes(user?.role?.name) && !event.message['analyzed']) || (event.message['analyzed'] && event.risks?.length)"
          icon="more_vert"
          color="none"
          textColor="secondary"
          [tooltip]="'stream.more_actions' | translate"
          [matMenuTriggerFor]="moreMenu">
        </lib-button>
        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item *ngIf="!event.endDate" (click)="openInviteDialog()">
            <mat-icon>person_add</mat-icon>
            <span>{{ 'stream.invite.title' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="event.message['analyzed'] && event.risks?.length" (click)="generatePDF(event)">
            <mat-icon>download</mat-icon>
            <span>{{ 'stream.download_report' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="!event.endDate && ['admin','dev'].includes(user?.role?.name)" (click)="markEventOver()">
            <mat-icon>meeting_room</mat-icon>
            <span>{{ 'stream.finish.session' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="!event.message['analyzed'] && ['admin','dev'].includes(user?.role?.name)" (click)="markAnalysisDone()">
            <mat-icon>task_alt</mat-icon>
            <span>{{ 'stream.finish.analysis' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="['admin','dev'].includes(user?.role?.name)" (click)="deleteSession()" style="color: var(--danger-color)">
            <mat-icon style="color: var(--danger-color)">delete</mat-icon>
            <span>{{ 'stream.delete_session.label' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="visit-details" *ngIf="event && !invitedAsPublisher(event)">
      <p><strong>{{ 'events.start' | translate }}:</strong> {{ event.startDate | date:'dd/MM/yyyy HH:mm' }}</p>
      <p *ngIf="event.endDate"><strong>{{ 'events.end' | translate }}:</strong> {{ event.endDate | date:'dd/MM/yyyy HH:mm' }}</p>
      <p *ngIf="event.duration"><strong>{{ 'events.duration' | translate }}:</strong> {{ event.duration }}</p>
      <p>
        <strong>{{ 'stream.status' | translate }}: </strong>
        <span *ngIf="event.message['analyzed'] && event.risks?.length">{{ event.risks?.length }} risque(s)</span>
        <span *ngIf="event.message['analyzed'] && !event.risks?.length">{{ 'stream.no_risks' | translate }}</span>
        <span *ngIf="!event.message['analyzed']">{{ 'stream.analyzing' | translate }}</span>
      </p>
    </div>

    <div class="upload-container" *ngIf="event">
      <h3>{{ 'stream.upload.title' | translate }}</h3>
      <div class="helper"></div>
      <app-file-input [accept]="'image/*,video/*'" [multiple]="true" [height]="90" [camera]="true" (change)="onSidebarFileSelected($event)" class="upload-file" [noPreview]="true">
      </app-file-input>
      <mat-progress-bar *ngIf="processingVideos > 0" mode="indeterminate" class="video-upload-bar"></mat-progress-bar>
    </div>

    <div class="visit-users" *ngIf="event && isTrackerVisit(event)">
      <h4>{{ 'stream.tracker' | translate }}</h4>
      <div class="user-row" *ngIf="event.message['broadcaster'] as saved; else noSavedTracker">
        <mat-icon class="role-icon publisher">videocam</mat-icon>
        <span class="user-name">{{ saved.name }}</span>
      </div>
      <ng-template #noSavedTracker>
        <p class="muted-text">{{ 'stream.no_tracker_stream' | translate }}</p>
      </ng-template>
    </div>

    <div class="visit-users" *ngIf="event">
      <h4>{{ 'stream.users' | translate }}</h4>
      <div class="user-row" *ngIf="event.host">
        <mat-icon class="role-icon publisher" [matTooltip]="'stream.role_streamer' | translate">videocam</mat-icon>
        <app-user-avatar [status]="hasJoined(event.host.email) ? 'on' : 'off'" [avatarUrl]="event.host.avatar" [fullName]="displayName(event.host)" [size]="40"></app-user-avatar>
        <span class="user-name">{{ displayName(event.host) }}</span>
      </div>
      <div class="user-row" *ngIf="event.invited?.length">
        <mat-icon class="role-icon viewer" [matTooltip]="((event.invited?.length || 0) > 1 ? 'stream.observers' : 'stream.role_observer') | translate">visibility</mat-icon>
        <div class="experts-avatars">
          <app-user-avatar *ngFor="let u of (event.invited || [])" [status]="hasJoined(u.email) ? 'on' : 'off'" [avatarUrl]="u.avatar" [fullName]="displayName(u)" [size]="40" [matTooltip]="displayName(u)"></app-user-avatar>
        </div>
      </div>
      <p class="muted-text" *ngIf="!event.host && !event.invited?.length">{{ 'stream.no_users' | translate }}</p>
    </div>

    <div class="visit-photos">
      <h4>{{ 'stream.captures' | translate }}</h4>
      <lib-no-data [message]="'stream.no_captures' | translate" size="small" *ngIf="!captures.length"></lib-no-data>
      <div class="photos-grid" *ngIf="captures.length">
        <div class="photo-item" *ngFor="let item of captures; trackBy: trackById"
          [class.publisher-unlabeled]="isHiddenForPublisher(item, event)"
          (click)="item.type === 'video' ? openSavedVideo(item) : handleImageClick(item, captures)">
          <ng-container *ngIf="!item.loading">
            <img [src]="item.thumbnail || item.url" [class.has-risk]="getFirstLabel(item)" />
            <mat-icon *ngIf="item.type === 'video' && !item.uploading" class="play-overlay">play_circle</mat-icon>
            <ng-container *ngTemplateOutlet="uploadOverlay; context: { $implicit: item }"></ng-container>
            <ng-container *ngIf="getFirstLabel(item) as label">
              <div class="label-overlay">
                <span class="label-name">{{ label.name }}</span>
                <div *ngIf="label.boundingBox" class="bounding-box" [ngStyle]="{
                  left: (label.boundingBox[0] * 100) + '%',
                  top: (label.boundingBox[1] * 100) + '%',
                  width: (label.boundingBox[2] * 100) + '%',
                  height: (label.boundingBox[3] * 100) + '%'
                }"></div>
              </div>
            </ng-container>
          </ng-container>
          <app-spinner *ngIf="item.loading" [diameter]="30" class="photo-loading" iconOnly></app-spinner>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div class="table-scroll">
    <table *ngIf="!loadingEvents" mat-table [dataSource]="eventsData" matSort class="images-table mat-elevation-z8">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="col-date">
          <div class="th-header" [matTooltip]="!isMobile ? '' : 'Date'">
            <mat-icon>calendar_today</mat-icon>
            <span *ngIf="!isMobile">Date</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let row" class="col-date">
          <p>
            <mat-icon *ngIf="isTrackerVisit(row)" class="visit-kind" [matTooltip]="'stream.tracker_visit' | translate">videocam</mat-icon>
            {{ row.startDate | date:'dd/MM/yyyy HH:mm' }}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="images">
        <th mat-header-cell *matHeaderCellDef class="col-images">
          <div class="th-header" [matTooltip]="!isMobile ? '' : 'Images'">
            <mat-icon>image</mat-icon>
            <span *ngIf="!isMobile">Images</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let row" class="col-images">
          <span class="thumb" *ngFor="let image of (row.captures || []).slice(0, 5); let i = index; trackBy: trackById"
            [class.publisher-unlabeled]="isHiddenForPublisher(image, row)">
            <ng-container *ngIf="!image.loading">
              <img
                [src]="image.thumbnail || image.url"
                class="image-thumbnail"
                [class.has-risk]="getFirstLabel(image)"
              />
              <mat-icon *ngIf="image.type === 'video'" class="play-overlay">play_circle</mat-icon>
            </ng-container>
            <app-spinner *ngIf="image.loading" [diameter]="22" class="thumb-spinner" iconOnly></app-spinner>
          </span>
          <span class="more-count" *ngIf="(row.captures || []).length > 5">+{{ (row.captures || []).length - 5 }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="col-status">
          <div class="th-header" [matTooltip]="!isMobile ? '' : ('stream.status' | translate)">
            <mat-icon>task_alt</mat-icon>
            <span *ngIf="!isMobile">{{ 'stream.status' | translate }}</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let row" class="col-status">
          <div class="row-status">
            @if(row.message['analyzed']) {
              @if(row.risks?.length > 0) {
                <lib-button icon="download" color="none" textColor="primary" [text]="isMobile ? '' : ('stream.download_report' | translate)" [loading]="loadingReport[row.id]" (click)="generatePDF(row)">
                </lib-button>
              } @else {
                <ng-container *ngTemplateOutlet="no_risks"></ng-container>
              }
            } @else if(!row.captures?.length) {
              <ng-container *ngTemplateOutlet="no_image"></ng-container>
            } @else {
              <ng-container *ngTemplateOutlet="analysing"></ng-container>
            }
          </div>

          <ng-template #no_risks>
            <span class="muted-text" *ngIf="!isMobile">
              {{ 'stream.no_risks' | translate}}
            </span>
            <span class="muted-text" *ngIf="isMobile">
              <mat-icon matTooltip="{{ 'stream.no_risks' | translate}}">task_alt</mat-icon>
            </span>
          </ng-template>

          <ng-template #analysing>
            <span class="muted-text" *ngIf="!isMobile">
              {{ 'stream.analyzing' | translate}}
            </span>
            <span class="muted-text" *ngIf="isMobile">
              <mat-icon matTooltip="{{ 'stream.analyzing' | translate}}">hourglass_empty</mat-icon>
            </span>
          </ng-template>

          <ng-template #no_image>
            <span class="muted-text" *ngIf="!isMobile">
              {{ 'stream.no_image' | translate}}
            </span>
            <span class="muted-text" *ngIf="isMobile">
              <mat-icon matTooltip="{{ 'stream.no_image' | translate}}">image_not_supported</mat-icon>
            </span>
          </ng-template>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="eventColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: eventColumns;"
        class="clickable-row"
        [class.selected]="event?.id == row.id"
        (click)="onRowClick(row)"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="eventColumns.length">
            <lib-no-data message="{{'form.search_no_data' | translate}}" description="form.search_no_data_desc"
                icon="search_off">
            </lib-no-data>
          </td>
      </tr>
    </table>
    </div>

    <!-- <mat-paginator #imagesPaginator [length]="imagesCount" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
        class="paginator">
    </mat-paginator> -->

    <div *ngIf="loadingEvents" class="table-overlay">
        <app-spinner></app-spinner>
    </div>
  </div>
</div>

<div class="room" *ngIf="isPublisher() || isViewer() || joiningRoom" [class.landscape-mode]="isLandscape">
  <div class="main-section {{getLayoutAspect()}}" [class.no-gallery]="!showGallery">
    <div class="no-publisher square" *ngIf="!publisher && !trackerBroadcaster">
      <lib-no-data [message]="(isTrackerVisit() ? 'stream.no_tracker_stream' : 'stream.no_publisher_present')|translate">
      </lib-no-data>
      <div class="add-tracker-stream" *ngIf="isViewer() && isTrackerVisit()">
        <strong>{{ 'stream.add_stream' | translate }}</strong>
        <lib-search-select
          [items]="projectTrackers"
          [selectedItem]="selectedTrackerName"
          [label]="'stream.tracker' | translate"
          [searchPlaceholder]="'stream.search_tracker' | translate"
          [valueKey]="'name'"
          [labelKey]="'name'"
          (itemChanged)="onTrackerSelected($event)">
        </lib-search-select>
        <lib-button
          color="primary"
          icon="add"
          text="{{ 'stream.add' | translate }}"
          [disabled]="!selectedTrackerName"
          (click)="addTrackerStream()">
        </lib-button>
      </div>
    </div>
    <div class="publisher-video-container landscape" *ngIf="!publisher && trackerBroadcaster">
      <div class="start-overlay" *ngIf="!trackerStreamLive">
        <app-spinner *ngIf="!trackerNoStream" class="loading-spinner" [diameter]="50" iconOnly></app-spinner>
        <div *ngIf="trackerNoStream" class="tracker-no-stream">
          <mat-icon class="no-stream-icon">videocam_off</mat-icon>
          <span>{{ 'dashboard.video.noStream' | translate }}</span>
        </div>
      </div>
      <video #trackerVideo autoplay playsinline muted></video>
      <div class="identity">
        <mat-icon>videocam</mat-icon>
        <span>{{ trackerBroadcaster }}</span>
        <span class="streaming-dot" *ngIf="trackerStreamLive"></span>
      </div>
      <div class="controls tracker-controls">
        <ng-container *ngIf="trackerStreamLive">
          <lib-button icon="photo_camera" color="primary" (click)="takePhoto()"></lib-button>
          <lib-button [icon]="isAutoCapturing ? 'stop_circle' : 'motion_photos_auto'" [color]="isAutoCapturing ? 'danger' : 'primary'" (click)="toggleAutoCapture()"></lib-button>
        </ng-container>
        <lib-button *ngIf="canToggleRecording()"
                    [icon]="recording ? 'stop_circle' : 'videocam'"
                    [color]="recording ? 'danger' : 'primary'"
                    [disabled]="!!recording && !canStopRecording()"
                    (click)="toggleRecording()"></lib-button>
        <lib-button *ngIf="canRemoveTracker() && trackerNoStream" icon="close" color="danger" [disabled]="!!recording" [tooltip]="'stream.remove_stream' | translate" (click)="removeTrackerStream()"></lib-button>
      </div>
      <div class="timer" *ngIf="recording">
        <mat-icon>fiber_manual_record</mat-icon>
        {{ recordingTime }}
      </div>
    </div>
    <div #publisherContainer class="publisher-video-container {{getAspectRatio()}}" *ngIf="publisher" [class.landscape-mode]="isLandscape">
      <div class="options">
        <lib-button *ngIf="publisher.camera" icon="videocam_on" color="none" textColor="secondary" [tooltip]="getCameraLabel(publisher)" (click)="toggleCamera(publisher)">
        </lib-button>
        <lib-button *ngIf="!publisher.camera" icon="videocam_off" color="none" textColor="danger" [tooltip]="getCameraLabel(publisher)" (click)="toggleCamera(publisher)">
        </lib-button>
        <lib-button *ngIf="!publisher.muted" icon="mic_on" color="none" textColor="secondary" [tooltip]="getMicLabel(publisher)" (click)="toggleMic(publisher)">
        </lib-button>
        <lib-button *ngIf="publisher.muted" icon="mic_off" color="none" textColor="danger" [tooltip]="getMicLabel(publisher)" (click)="toggleMic(publisher)">
        </lib-button>
        <lib-button *ngIf="isPublisher()" [matMenuTriggerFor]="menu" icon="aspect_ratio"  textColor="secondary" color="none" matTooltip="Aspect ratio">
        </lib-button>
        <mat-menu #menu="matMenu">
          <mat-button-toggle-group
            name="Aspect ratio"
            aria-label="{{'stream.aspect.title'|translate}}"
            [hideSingleSelectionIndicator]="true"
            [value]="aspect"
            (change)="onAspectChange($event)"
          >
            <mat-button-toggle value="1:1" matTooltip="{{'stream.aspect.square' | translate}}">
              <mat-icon>crop_square</mat-icon>
            </mat-button-toggle>

            <!-- <mat-button-toggle [disabled]="isLandscape && isMobile" value="9:16" matTooltip="{{'stream.aspect.portrait' | translate }}">
              <mat-icon>stay_current_portrait</mat-icon>
            </mat-button-toggle> -->

            <mat-button-toggle [disabled]="!isLandscape && isMobile" value="16:9" matTooltip="{{'stream.aspect.landscape' | translate }}">
              <mat-icon>crop_16_9</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </mat-menu>
      </div>
      <div class="bottom-options">
        <lib-button *ngIf="publisher.geoloc" icon="location_on" color="none" textColor="secondary" [tooltip]="getGeolocLabel(publisher)" (click)="toggleGeoloc(publisher)">
        </lib-button>
        <lib-button *ngIf="!publisher.geoloc" icon="location_off" color="none" textColor="danger" [tooltip]="getGeolocLabel(publisher)" (click)="toggleGeoloc(publisher)">
        </lib-button>

      </div>
      <div class="start-overlay" *ngIf="!publisher.streaming || publisher.connecting">
        <lib-button
          *ngIf="isPublisher()"
          color="primary"
          text="{{'stream.start'|translate}}"
          icon="play_circle"
          (click)="startMainStream()"
          [loading]="loading">
        </lib-button>
        <app-spinner *ngIf="!isPublisher() && publisher?.connecting && publisher.streaming" class="loading-spinner" [diameter]="50" iconOnly></app-spinner>
        <!-- Publisher has joined but not started yet: viewers get a "no camera" icon instead of a black frame. -->
        <mat-icon *ngIf="!isPublisher() && !publisher.streaming && !publisher.connecting" class="no-stream-icon">videocam_off</mat-icon>
      </div>
      <div class="autoplay-blocked-overlay" *ngIf="publisher && autoplayBlocked.has(publisher.email)" (click)="resumeVideo(publisher.email)">
        <mat-icon>play_circle</mat-icon>
      </div>
      <div class="camera-switching-overlay" *ngIf="isSwitchingCamera">
        <app-spinner [diameter]="50" iconOnly></app-spinner>
      </div>
      <video #publisherVideo autoplay playsinline [class.connecting]="publisher?.connecting"></video>
      <!--<app-video-detections
        *ngIf="detectionsActive && publisher?.streaming"
        [room]="room"
        [peerId]="publisher.email"
        [containerEl]="publisherContainer"
        [autoStart]="hasInitDetections">
      </app-video-detections>-->
      <div class="identity" *ngIf="publisher">
        <app-user-avatar [avatarUrl]="publisher.avatar" [fullName]="displayName(publisher)" [size]="22"></app-user-avatar>
        <span>{{ publisher.name }}</span>
        <span class="streaming-dot" *ngIf="publisher.streaming"></span>
      </div>
      <div class="controls" *ngIf="publisher.streaming">
        <lib-button *ngIf="!isPublisher()" icon="photo_camera" color="primary" (click)="takePhoto()"></lib-button>
        <lib-button *ngIf="!isPublisher()" [icon]="isAutoCapturing ? 'stop_circle' : 'motion_photos_auto'" [color]="isAutoCapturing ? 'danger' : 'primary'" (click)="toggleAutoCapture()"></lib-button>
        <!--<lib-button *ngIf="!isPublisher()" [svgIcon]="detectionsActive ? 'detection_and_zone' : 'detection_and_zone_off'" [color]="detectionsActive ? 'danger' : 'primary'" (click)="toggleDetections()"></lib-button>-->
        <lib-button *ngIf="canToggleRecording()"
                    [icon]="recording ? 'stop_circle' : 'videocam'"
                    [color]="recording ? 'danger' : 'primary'"
                    [disabled]="!!recording && !canStopRecording()"
                    (click)="toggleRecording()"></lib-button>
        <lib-button *ngIf="hasMultipleCameras && isPublisher()" icon="cameraswitch" [disabled]="isSwitchingCamera" (click)="switchCamera()"></lib-button>
        <lib-button *ngIf="isPublisher()" icon="call_end" color="danger" (click)="stopStream()"></lib-button>
      </div>
      <div class="timer" *ngIf="recording">
        <mat-icon>fiber_manual_record</mat-icon>
        {{ recordingTime }}
      </div>
    </div>


    <!-- Viewer (right/floating) -->
    <div class="viewer-section {{getLayoutAspect()}}">
      <div class="no-viewer" *ngIf="!viewers.length">
        {{ 'stream.no_viewer' | translate }}
      </div>
      <div class="viewer-video-container"
        *ngFor="let viewer of viewers; trackBy: trackByViewerId" [ngClass]="{ 'multiple': viewers.length > 2, 'streaming': viewer.streaming, 'no-camera': !viewer.camera }">
        <div class="options">
          <lib-button *ngIf="viewer.camera && isCurrentUser(viewer)" icon="videocam_on" color="none" textColor="secondary" [tooltip]="getCameraLabel(viewer)" (click)="toggleCamera(viewer)">
          </lib-button>
          <lib-button *ngIf="!viewer.camera && isCurrentUser(viewer)" icon="videocam_off" color="none" textColor="danger" [tooltip]="getCameraLabel(viewer)" (click)="toggleCamera(viewer)">
          </lib-button>
          <lib-button *ngIf="!viewer.muted" icon="mic_on" color="none" textColor="secondary"
            [tooltip]="getMicLabel(viewer)"  (click)="toggleMic(viewer)">
          </lib-button>
          <lib-button *ngIf="viewer.muted" icon="mic_off" color="none" textColor="danger" [tooltip]="getMicLabel(viewer)" (click)="toggleMic(viewer)">
          </lib-button>
        </div>
        <!-- *ngIf="!viewer.streaming && isCurrentUser(viewer)" -->
        <div class="start-overlay" *ngIf="!viewer.streaming || viewer.connecting">
          <lib-button
            *ngIf="!viewer.streaming && isCurrentUser(viewer)"
            color="primary"
            icon="play_circle"
            (click)="startViewerStream(viewer)">
          </lib-button>
          <app-spinner *ngIf="!isViewer() && viewer?.connecting && viewer.streaming" class="loading-spinner" [diameter]="50" iconOnly></app-spinner>
          <mat-icon *ngIf="!viewer.streaming && viewer.camera && !isCurrentUser(viewer)" class="no-stream-icon">videocam_off</mat-icon>
        </div>
        <div class="autoplay-blocked-overlay" *ngIf="autoplayBlocked.has(viewer.email)" (click)="resumeVideo(viewer.email)">
          <mat-icon>play_circle</mat-icon>
        </div>
        <video #viewerVideo autoplay playsinline [class.connecting]="viewer?.connecting"></video>
        <mat-icon *ngIf="!viewer.camera" class="camera-off-badge">videocam_off</mat-icon>
        <lib-button
          *ngIf="viewer.streaming && isCurrentUser(viewer)"
          class="viewer-stop"
          icon="call_end"
          color="danger"
          (click)="stopViewerStream()">
        </lib-button>
        <div class="identity" *ngIf="viewer" [ngClass]="{'no-camera': !viewer.camera }">
          <app-user-avatar [avatarUrl]="viewer.avatar" [fullName]="displayName(viewer)" [size]="22" [fill]="!viewer.camera"></app-user-avatar>
          <span class="streaming-dot" *ngIf="viewer.streaming && viewer.camera"></span>
          <!-- <span>{{ viewer.name }}</span> -->
        </div>
        <div class="identity" *ngIf="!viewer">
          <span>VIEWER</span>
        </div>
      </div>
    </div>


  </div>
  <ng-container *ngTemplateOutlet="gallery; context: { images: captures, isMobile: isMobile, isLandscape: isLandscape }"></ng-container>

  <!-- Fullscreen Modal -->
  <div class="fullscreen-view" *ngIf="fullscreenMedia" (click)="closeFullscreen()">
    <img *ngIf="fullscreenType === 'photo'" [src]="fullscreenMedia" />
    <video *ngIf="fullscreenType === 'video'" [src]="fullscreenMedia" controls autoplay></video>
  </div>

  <div class="event-time-badge" *ngIf="isMobile && event">
    <mat-icon>schedule</mat-icon>
    <span>{{ event.startDate | date:'dd/MM HH:mm' }}</span>
  </div>

  <canvas #canvasElement style="display: none;"></canvas>
</div>

<ng-template #sessionDateBadge let-showLabel="showLabel">
  <div class="session-date-badge" *ngIf="event">
    <mat-icon>event</mat-icon>
    <span><strong *ngIf="showLabel !== false">{{'events.start'|translate}}:</strong> {{ event.startDate | date:'dd/MM/yyyy HH:mm' }}</span>
    <span *ngIf="event.endDate"> &nbsp;–&nbsp; <strong *ngIf="showLabel !== false">{{'events.end'|translate}}:</strong> {{ event.endDate | date:'dd/MM/yyyy HH:mm' }}</span>
  </div>
</ng-template>

<!-- Gallery -->
<ng-template #gallery let-images="images" let-isMobile="isMobile" let-isLandscape="isLandscape">
  <div class="gallery" *ngIf="showGallery" [class.landscape]="isLandscape">
    <h4 class="images-title" *ngIf="!isMobile">Captures</h4>
    <lib-no-data [message]="'stream.no_captures' | translate" *ngIf="!images.length"></lib-no-data>
    <div class="gallery-items" *ngIf="images.length">
        <div
        *ngFor="let item of images; let i = index; trackBy: trackById"
        class="gallery-item"
        [class.publisher-unlabeled]="isHiddenForPublisher(item)"
        (click)="handleImageClick(item)">
        <img *ngIf="item.type !== 'video' && !item.loading" [src]="item.url" alt="Gallery image"/>
        <div class="video-thumb" *ngIf="item.type === 'video' && !item.loading" (click)="openSavedVideo(item); $event.stopPropagation()">
          <img [src]="item.thumbnail || item.url" alt="Vidéo" />
          <mat-icon *ngIf="!item.uploading" class="play-overlay">play_circle</mat-icon>
          <ng-container *ngTemplateOutlet="uploadOverlay; context: { $implicit: item }"></ng-container>
        </div>
        <app-spinner *ngIf="item.loading" class="loading-spinner" [diameter]="30" iconOnly></app-spinner>
        <ng-container *ngIf="getFirstLabel(item) as label">
          <div class="label-overlay">
            <span class="label-name">{{ label.name }}</span>
            <div *ngIf="label.boundingBox" class="bounding-box" [ngStyle]="{
              left: (label.boundingBox[0] * 100) + '%',
              top: (label.boundingBox[1] * 100) + '%',
              width: (label.boundingBox[2] * 100) + '%',
              height: (label.boundingBox[3] * 100) + '%'
            }"></div>
          </div>
        </ng-container>
        <div class="action-btns" *ngIf="!item.loading">
          <lib-button icon="download" color="secondary" customClass="solid-hover" class="action" (click)="downloadCapture(item, i)"></lib-button>
          <lib-button icon="delete" color="danger" customClass="solid-hover" class="action" (click)="deleteCapture(i)"></lib-button>
        </div>
      </div>
    </div>
    <lib-button icon="close" color="none" textColor="danger" (click)="toggleGallery()" class="close"></lib-button>
  </div>
</ng-template>

<ng-template #uploadOverlay let-item>
  <div class="upload-overlay" *ngIf="item.uploading"
    [matTooltip]="(item.uploadStage === 2 ? 'stream.upload.video_stage_saving' : item.uploadStage === 1 ? 'stream.upload.video_stage_sending' : 'stream.upload.video_stage_queued') | translate">
    <div class="upload-ring" [class.saving]="item.uploadStage === 2">
      <svg viewBox="0 0 36 36">
        <circle class="track" cx="18" cy="18" r="16" pathLength="100"></circle>
        <circle class="bar" cx="18" cy="18" r="16" pathLength="100" [attr.stroke-dasharray]="(item.uploadProgress || 0) + ' 100'"></circle>
      </svg>
      <span class="percent" *ngIf="item.uploadStage; else queuedIcon">{{ item.uploadProgress || 0 }}%</span>
      <ng-template #queuedIcon><mat-icon class="percent">schedule</mat-icon></ng-template>
    </div>
  </div>
</ng-template>